var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as API from './api';
let UserManage = class UserManage extends Vue {
    constructor() {
        super(...arguments);
        this.users = null;
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            let users = yield API.listUser();
            if (users !== 'Error') {
                this.users = users;
            }
        });
    }
    onApplyUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Apply User?')) {
                if ((yield API.setUser(user)) === 'Error') {
                    alert('Apply Failed!');
                }
                else {
                    alert('Apply Success!');
                }
            }
        });
    }
    onLoginUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm(`Log in to user ${user.name}?\nWarning: You will NOT be able to switch back without re-logging in.`)) {
                let result = yield API.emit(`/user/${user.uid}/impersonate`);
                switch (result) {
                    case 'Success':
                        location.href = '/';
                        break;
                    default:
                        alert('failed');
                        break;
                }
            }
        });
    }
    onRemoveUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Remove User?')) {
                if (this.users !== null) {
                    if ((yield API.removeUser(user.uid)) === 'Success') {
                        let index = this.users.indexOf(user);
                        this.users.splice(index, 1);
                        alert('Remove Success!');
                    }
                    else {
                        alert('Remove Failed!');
                    }
                }
                else {
                    alert('User Does Not Exist!');
                }
            }
        });
    }
};
UserManage = __decorate([
    Component
], UserManage);
export default UserManage;



// WEBPACK FOOTER //
// ./src/UserManage.vue